export default __webpack_public_path__ + "static/810-fa9062b33befc0317b642e94dd1abdf2.gif";